import { Shop, ProductType, TipsterInfo } from '../shared/interfaces';
import { PremiumProduct } from './interfaces/PremiumProduct';

export class PremiumShop implements Shop {
  type: ProductType = 'PREMIUM';
  products: PremiumProduct[] = [];
  selectedProduct: PremiumProduct;
  tipsterInfo: TipsterInfo;
  hasWebPlans: boolean = false;

  constructor(
    products: PremiumProduct[],
    tipsterInfo: TipsterInfo,
    selectedProductNum?: number,
  ) {
    this.products = products;
    this.selectedProduct = products[selectedProductNum || 0];
    this.tipsterInfo = tipsterInfo;

    if (products.length > 0) {
      this.hasWebPlans = true;
    }

    this.setInitialSelectedProduct(selectedProductNum);
  }

  private setInitialSelectedProduct(
    selectedProductNum: number | undefined,
  ): void {
    if (selectedProductNum !== undefined) {
      return;
    } else {
      let maxDiscount = 0;
      let selectedProductWithMaxDiscount = null;

      for (let i = this.products.length - 1; i >= 0; i--) {
        if (this.products[i].discountPercentage > 0) {
          if (maxDiscount < this.products[i].discountPercentage) {
            maxDiscount = this.products[i].discountPercentage;
            selectedProductWithMaxDiscount = this.products[i];
          } else if (maxDiscount === this.products[i].discountPercentage) {
            if (
              selectedProductWithMaxDiscount === null ||
              selectedProductWithMaxDiscount.price.amount >
                this.products[i].price.amount
            ) {
              selectedProductWithMaxDiscount = this.products[i];
            }
          }
        }
      }
      this.selectedProduct = selectedProductWithMaxDiscount || this.products[0];
    }
  }

  public handleSelectProduct(product: PremiumProduct): void {
    this.selectedProduct = product;
  }
}
